<template>
    <b-button
        id="tour-dashboard-step-1"
        v-if="!isEditMode && viewTypeIsWeb"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        @click="setCustomDashboard"
        class="pl-1 pr-1"
        style='background-color: rgba(115, 103, 240, 0.12);'
    >
        {{ $t('v4.Edit Dashboard') }}
    </b-button>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import useDashboardRender from '@/composables/useDashboardRender'
import { computed } from '@vue/composition-api'
export default {
    directives: {
        Ripple
    },
    props: {
        isEditMode: {
            type: Boolean,
            default: false
        }
    },
    setup (props, context) {
        const { viewType } = useDashboardRender()
        const setCustomDashboard = () => context.emit('setCustomDashboard', true)
        const viewTypeIsWeb = computed(() => viewType.value === 'web')
        return {
            setCustomDashboard,
            viewTypeIsWeb
        }
    }
}
</script>
